import Axios from "axios";
export default async (url: string) => {
  const s = url.split("?");
  if (/(\.pdf|\.png|\.jpg|\.jpeg)$/i.test(s[0])) {
    return url;
  } else {
    return (await Axios.get(url)).data;
  }
};
